( function () {
	'use strict';

	function mcInfo () {
		return {
			'templateUrl' : '/templates/components/ppd/mc/mc-info.html',
			'restrict'    : 'E',
			'replace'     : true,
			'scope'       : {
				'item' : '=',
				'url'  : '='
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'mcInfo', mcInfo );
} )( );
